import { Pipe, PipeTransform } from '@angular/core';
import {
  enumEquals,
  ProjectJobPermitStatus,
  ProjectJobPermitStatusSchema,
  ProjectPermitTaskServiceCreateResponseJson,
} from '@vmspdb/definitions';

@Pipe({
  name: 'enumPermitStatusColor',
  standalone: false,
})
export class EnumPermitStatusColorPipe implements PipeTransform {
  transform(value?: ProjectPermitTaskServiceCreateResponseJson): string {
    if (!value?.milestones?.length) {
      return '';
    }

    if (
      value.milestones.some((milestone) =>
        enumEquals(
          ProjectJobPermitStatusSchema,
          ProjectJobPermitStatus.SENT_TO_CLIENT,
          milestone.status ?? '',
        ),
      )
    ) {
      return 'status-archived';
    }

    return '';
  }
}
